
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {TeamModel} from '@/models/team.model';
  import {
    authModule,
    i18nModule,
    publicProfileModule,
    publicProfileState,
    userModule,
    userState,
    userTeamsModule,
    userTeamsState
  } from '@/utils/store-acessor';
  import {UserModel} from '@/models/user.model';
  import ListTeams from '@/components/Shared/ListTeams.vue';
  import {LocaleSelectorType} from '@/store/i18n.store.module';
  import {UserTeamsApi} from '@/api/user-teams.api';
  import {take} from 'rxjs/operators';

  @Component({
    components: {
      ListTeams
    }
  })
  export default class ProfileTeams extends Vue {
    @userModule.Getter('user') user!: UserModel;
    @userTeamsModule.Getter('loading') loading!: boolean;
    @userTeamsModule.Getter('entities') teams!: TeamModel[];
    @userTeamsModule.Getter('currentPage') currentPage!: number;
    @userTeamsModule.Getter('lastPage') lastPage!: number;
    @userTeamsModule.Getter('total') total!: number;
    @publicProfileModule.Getter('publicProfile')
    publicProfile!: UserModel;
    @i18nModule.Getter('locale') selected!: LocaleSelectorType;
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
    profileTeams: TeamModel[] = [];
    profileName: string | undefined = '';
    publicTeamsLoading: boolean = false;
    isPublic: boolean = false;

    async mounted() {
      this.isPublic = this.$route.params.slug !== 'me';
      if (this.$route.params.slug === 'me') {
        this.getMeTeams();
      } else {
        this.getPublicTeams(this.$route.params.slug);
      }
    }

    async getMeTeams() {
      await userState.fetchUser();
      if (this.user?.slug) {
        await userTeamsState.fetchUserTeams({page: 1, userSlug: this.user.slug});
        this.profileTeams = this.teams;
      }
    }

    async getPublicTeams(slug: string) {
      this.publicTeamsLoading = true;
      if (!this.publicProfile?.id) {
        await publicProfileState.fetchPublicProfile(this.$route.params.slug);
      }
      try {
        this.profileName = this.publicProfile?.full_name;
        await new UserTeamsApi().fetchMyTeams(slug).pipe(take(1)).toPromise().then(teams => {
          this.profileTeams = teams.data;
        });
        this.publicTeamsLoading = false;
      } catch (e) {
        this.publicTeamsLoading = false;
      }
    }

    async nextPage() {
      if (this.user.slug) {
        if (this.currentPage < this.lastPage) {
          await userTeamsState.fetchUserTeams({
            page: this.currentPage + 1,
            userSlug: this.user.slug
          });
        }
      }
    }
  }
